import axios, { AxiosError } from "axios";
import AuthClient from "./AuthClient";
import { ApiResponse, handleAxiosError } from "./responses/AxiosResponseHandler";
import { HostChatMessage } from "../types";
import { parseHostChatMessages } from "./parseResponse/parseHostChatMessages";

class GetHostChatMessages {

    private authClient: AuthClient;
    constructor(authClient: AuthClient) {
        this.authClient = authClient;
    }

    public async getChatMessages(offerId: string): Promise<ApiResponse<HostChatMessage[]>> {
        try {

            const authenticationResponse = this.authClient.getAuthenticationResponse();
            const response = await axios.get(
                `${this.authClient.getApiRoot()}/group/chatMessages/${offerId}`,
                {
                    headers: {
                        Authorization: `Bearer ${authenticationResponse?.token}`,
                    },
                }
            );

            return {
                statusCode: response.status,
                errorMessage: "",
                data: parseHostChatMessages(response.data as string[])
            };
        } catch (error) {
            const errorResponse = handleAxiosError<HostChatMessage[]>(error as AxiosError);
            return {
                statusCode: errorResponse.statusCode,
                errorMessage: errorResponse.errorMessage,
                data: errorResponse.data,
            };
        }
    }

}

export default GetHostChatMessages;
